import script from "./UserDatasetEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDatasetEditor.vue?vue&type=script&setup=true&lang=ts"

import "./UserDatasetEditor.vue?vue&type=style&index=0&id=f1f5caf2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f5caf2"]])

export default __exports__